import { memo } from 'react';
import { ScanLine, Monitor, Printer } from 'lucide-react';
import { MODES, modesJouablesFormat, modesJouablesPayload } from '../../utils/modePassation';

const ICONES = { aruco: ScanLine, en_ligne: Monitor, papier: Printer };
/* Une couleur par destination, la même que les boutons de lancement en bas
   de page (indigo cartes, turquoise en ligne, ambre papier, 2026-09-03) :
   le prof reconnaît d'un coup d'œil où l'exercice se joue. */
const COULEURS = { aruco: 'text-indigo-500', en_ligne: 'text-teal-600', papier: 'text-amber-500' };

/**
 * Icônes de compatibilité d'un exercice avec les modes de passation :
 * information pendant la composition, jamais une décision (chantier
 * composition, 2026-09-02). Un QCM à réponse unique montre les trois icônes,
 * une saisie deux (en ligne, papier) : le prof VOIT avant de cliquer
 * « En classe (cartes) » ce qui s'y jouera.
 *
 * `format` = { key, label } d'une carte d'exerciseur (avant génération),
 * ou `payload` = question/exercice généré. Composant de présentation pur.
 */
const IconesModes = memo(function IconesModes({ format, payload, className = '' }) {
    const jouables = new Set(format ? modesJouablesFormat(format) : modesJouablesPayload(payload));
    const libelle = MODES.filter((m) => jouables.has(m.id)).map((m) => m.label).join(', ');
    return (
        <span
            className={`inline-flex items-center gap-0.5 ${className}`}
            title={libelle ? `Se joue ${libelle}` : 'Ne se joue dans aucun mode'}
            aria-label={libelle ? `Se joue ${libelle}` : 'Ne se joue dans aucun mode'}
        >
            {MODES.map((m) => {
                const Icone = ICONES[m.id];
                const ok = jouables.has(m.id);
                return (
                    <Icone
                        key={m.id}
                        size={11}
                        className={ok ? COULEURS[m.id] : 'text-gray-200'}
                        aria-hidden="true"
                    />
                );
            })}
        </span>
    );
});

export default IconesModes;
